import React from 'react';

const PERIOD_OPTIONS = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'yearly', label: 'Yearly' }
];

function PerformanceContextBar({
  title = 'Performance Context',
  context,
  onChange,
  locations = [],
  selectedLocationCode,
  allLocationsValue = 'ALL',
  search = '',
  onSearchChange,
  searchPlaceholder = 'Search KPI...',
  children = null
}) {
  const isLocationLocked = selectedLocationCode !== allLocationsValue;

  return (
    <section className="director-card director-performance-context-card">
      <div className="role-section-header">
        <h2>{title}</h2>
        <span>{context.periodType === 'yearly' ? 'YTD / Yearly' : 'MTD / Monthly'}</span>
      </div>
      <div className="director-toolbar director-performance-context-bar">
        <label className="director-toolbar-group">
          Location
          <select
            value={context.locationCode}
            onChange={(event) => onChange('locationCode', event.target.value)}
            disabled={isLocationLocked}
          >
            <option value="">Select location</option>
            {locations.map(location => (
              <option key={location.id} value={location.code}>
                {location.code} - {location.name}
              </option>
            ))}
          </select>
        </label>
        <label className="director-toolbar-group">
          Period Type
          <select value={context.periodType} onChange={(event) => onChange('periodType', event.target.value)}>
            {PERIOD_OPTIONS.map(option => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </label>
        <label className="director-toolbar-group">
          Year
          <input
            type="number"
            value={context.year}
            onChange={(event) => onChange('year', event.target.value)}
          />
        </label>
        {context.periodType === 'monthly' ? (
          <label className="director-toolbar-group">
            Month
            <input
              type="number"
              min="1"
              max="12"
              value={context.month}
              onChange={(event) => onChange('month', event.target.value)}
            />
          </label>
        ) : null}
        {typeof onSearchChange === 'function' ? (
          <label className="director-toolbar-group director-toolbar-search">
            Search
            <input
              value={search}
              onChange={(event) => onSearchChange(event.target.value)}
              placeholder={searchPlaceholder}
            />
          </label>
        ) : null}
        {children}
      </div>
    </section>
  );
}

export default PerformanceContextBar;
